import { AppsClient } from 'pbts/c1/api/app/v1/app.client'
import { AppIcon, AppIconRef, BulkGetAppIconsRequest, BulkGetAppIconsResponse } from 'pbts/c1/api/assets/v1/app_icons'
import { AppIconServiceClient } from 'pbts/c1/api/assets/v1/app_icons.client'
import { createMultiGetApi, MultiGetOpts } from './lib/createMultiGetApi'
import { createMutationApi } from './lib/createMutationApi'

// Create the mutation API for setAppIcon
export const setAppIconApi = createMutationApi(
    AppsClient,
    'setAppIcon',
    undefined,
    AppIconRef.typeName,
)

const multiGetOpts: MultiGetOpts<AppIconRef, BulkGetAppIconsRequest, BulkGetAppIconsResponse, AppIcon> = {
    buildRequest: (refs: AppIconRef[]) => ({
        appIcons: refs,
    }),
    transformResponse: (res: BulkGetAppIconsResponse) => {
        return res.list
    },
    refExtractor: (item: AppIcon) => {
        if (!item.appIcon) {
            throw new Error('AppIcon missing appIcon field')
        }
        return item.appIcon
    },
    maxBatchSize: 100,
    tag: AppIconRef.typeName,
    watchInserts: true,
}

export const getAppIconApi = createMultiGetApi(
    AppIconServiceClient,
    'bulkGetAppIcons',
    multiGetOpts,
)
